// extracted by mini-css-extract-plugin
export default {"btnContainer":"ErrorModal_btnContainer__3l999"};